module.exports = __webpack_public_path__ + "media/src/website/images/locations/muehldorf/profile-ab44f52abdcc72f2cd947c7c1170fe95.jpg";